/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Onboarding } from "./Onboarding";
export const OnboardingsResponse = core.serialization.object({
    data: core.serialization.list(Onboarding),
});
